{
  "actions": "Akcie",
  "hideButtonLabel": "Zobraziť menej",
  "noTags": "Žiadne",
  "showAllButtonLabel": "Zobraziť všetko ({tagCount, number})"
}
